import { defineMessages } from '@transcend-io/internationalization';

export const repositoryFilterMessages = defineMessages(
  'admin-dashboard.CodeScanning.components.RepositoryFilter.repositoryFilter',
  {
    textLabel: { defaultMessage: 'Search Repositories' },
    sdks: { defaultMessage: 'SDKs' },
  },
);
